var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.66667V17.7556C5 18.1912 5 18.4088 5.08477 18.5752C5.15934 18.7215 5.27824 18.8407 5.42459 18.9153C5.5908 19 5.8085 19 6.24324 19H14.3334M15.8889 8.88889L12.7778 12L11.2222 10.4444M8.11111 13.4002V7.48904C8.11111 6.61785 8.11111 6.18193 8.28066 5.84918C8.42979 5.55648 8.66759 5.31868 8.96029 5.16955C9.29304 5 9.72896 5 10.6002 5H16.5113C17.3825 5 17.8178 5 18.1506 5.16955C18.4433 5.31868 18.6815 5.55648 18.8306 5.84918C19.0002 6.18192 19.0002 6.61754 19.0002 7.48872L19.0002 13.3998C19.0002 14.271 19.0002 14.7066 18.8306 15.0394C18.6815 15.3321 18.4433 15.5704 18.1506 15.7195C17.8181 15.8889 17.3834 15.8889 16.5139 15.8889H10.5976C9.72811 15.8889 9.29271 15.8889 8.96029 15.7195C8.66759 15.5704 8.42979 15.3322 8.28066 15.0395C8.11111 14.7067 8.11111 14.2713 8.11111 13.4002Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f363087e42be959a60243d4a01fc7387.svg";
export { ForwardRef as ReactComponent };